import React, { useEffect, useState } from "react";
import NavIcon from "./NavIcon";
import "./style.scoped.scss";
import { NavLink, useRouteMatch } from "react-router-dom";
import cn from "classnames";
import links from "../../../links";
import { selectIsAdminAuthenticated, useAppSelector } from "../../../store";

type Props = {};
function Header(props: Props) {
  const [showHeader, setShowHeader] = useState(false);
  const isAdminAuthenticated = useAppSelector(selectIsAdminAuthenticated);
  const match = useRouteMatch();
  const filteredLinks = links.filter(
    (ev) => ev.href !== "/admin" || isAdminAuthenticated
  );

  // console.log(match);

  useEffect(() => {
    if (match.isExact) setShowHeader(false);
    else setShowHeader(true);
  }, [match.isExact]);

  return (
    <header className={cn("header", { "show-header": showHeader })}>
      <nav className="header-nav">
        {filteredLinks &&
          filteredLinks.map((item, index) => {
            return (
              <React.Fragment key={index}>
                {(item.external && (
                  <a href={item.href} target="_blank" rel="noopener noreferrer">
                    <div className="icon-margin">
                      <NavIcon iconSrc={item.iconSrc} name={item.name} />
                    </div>
                  </a>
                )) || (
                  <NavLink to={item.href} activeClassName="active-link" exact>
                    <div className="icon-margin">
                      <NavIcon iconSrc={item.iconSrc} name={item.name} />
                    </div>
                  </NavLink>
                )}
              </React.Fragment>
            );
          })}
      </nav>

      <div className="vertical-text">CLARENCE MANUEL</div>
    </header>
  );
}

export { Header as default };
